import {
  Textarea as FluentTextarea,
  TextareaProps as FluentTextareaProps,
} from '@fluentui/react-components';
import React, { forwardRef } from 'react';
import { useInputAppearance } from '../hooks';

export type TextareaProps = FluentTextareaProps;

/**
 * Themed Textarea wrapper that automatically applies the correct
 * filled appearance based on the current theme (dark/light).
 * The appearance can still be overridden via props.
 */
export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ appearance, ...props }, ref) => {
    const themedAppearance = useInputAppearance();

    return (
      <FluentTextarea
        ref={ref}
        appearance={appearance ?? themedAppearance}
        {...props}
      />
    );
  },
);

Textarea.displayName = 'Textarea';
